import { Upload } from 'lucide-react';
import ImportWizard from '../../component/import/ImportWizard';

// Colunas reais aceitas por `POST /stock/import` (product/importer.go) —
// nomes/obrigatoriedade extraídos da validação do backend
// (`checkLineHasErros`/`validMoney`), não do mock do protótipo (que usava
// nomes fictícios como "sku"/"preco"/"fornecedor"): "custo_do_produto" e
// "quantidade_minima" aceitam string vazia (`money.ParseMoneyFromString`
// trata "" como zero), "sub_categoria_produto" e "descricao" não são
// validados; os demais são obrigatórios.
const TEMPLATE_COLUMNS = [
    { key: 'codigo_produto', required: true, type: 'Texto', example: '4471' },
    { key: 'nome_produto', required: true, type: 'Texto (máx. 24)', example: 'Pastilha Freio Diant' },
    { key: 'categoria_produto', required: true, type: 'Texto', example: 'Peças de Freio' },
    { key: 'sub_categoria_produto', required: false, type: 'Texto', example: 'Pastilhas' },
    { key: 'custo_do_produto', required: false, type: 'Decimal', example: '120,00' },
    { key: 'valor_venda_produto', required: true, type: 'Decimal (> 0)', example: '189,90' },
    { key: 'quantidade', required: true, type: 'Inteiro', example: '24' },
    { key: 'quantidade_minima', required: true, type: 'Inteiro', example: '5' },
    { key: 'descricao', required: false, type: 'Texto', example: 'Cerâmica, jogo com 4 peças' },
];

const PREVIEW_HEADERS = ['codigo_produto', 'nome_produto', 'categoria_produto', 'valor_venda_produto', 'quantidade'];
const PREVIEW_ROWS = [
    ['4471', 'Pastilha Freio Diant', 'Peças de Freio', '189,90', '24'],
    ['5820', 'Filtro de Óleo Blindado', 'Filtros', '42,50', '58'],
    ['3390', 'Amortecedor Traseiro', 'Suspensão', '310,00', '12'],
];

export default function Import() {
    return (
        <ImportWizard
            pageIcon={Upload}
            pageTitle="Importar produtos"
            pageDescription="Cadastre vários produtos de uma vez a partir de uma planilha CSV."
            backTo="/products"
            backLabel="Voltar para produtos"
            templateHref="/modelo.csv"
            templateFileName="modelo_importacao_produtos.csv"
            templateColumns={TEMPLATE_COLUMNS}
            previewHeaders={PREVIEW_HEADERS}
            previewRows={PREVIEW_ROWS}
            importEndpoint={(separator) => `/stock/import?comma=${separator}`}
            entityLabelPlural="produtos"
            mobileTip="Não repita códigos na planilha: códigos duplicados impedem a importação."
        />
    );
}
